import React from "react";
import { Group, Text, Button, Tooltip } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { setActiveRoomColoringIdInRedux } from "../../designSlice";
import {
  selectDrofusOccurrenceValidationStandardRoomRows,
  selectActiveRoomColoringId,
} from "../DrofusOccurrenceValidationBarSelectors";

export const DrofusOccurrenceValidationStandardRoomSection: React.FC = () => {
  const dispatch = useAppDispatch();

  const rows = useAppSelector(selectDrofusOccurrenceValidationStandardRoomRows);
  const activeRoomColoringId = useAppSelector(selectActiveRoomColoringId);

  return (
    <Group gap="xs" align="center" wrap="wrap">
      {rows.map((row) => {
        const poengActive = row.validationId && activeRoomColoringId === row.validationId;
        const beslutningActive = row.decisionId && activeRoomColoringId === row.decisionId;

        return (
          <Group className="validation-discipline" key={row.discipline} gap={4} align="center" wrap="nowrap">
            <Tooltip
              label={row.discipline === "E" ? "RIE · Elektro" : row.discipline === "V" ? "RIV · VVS" : `Disiplin: ${row.discipline}`}
              position="bottom"
              withArrow
              openDelay={250}
            >
              <Text size="sm" fw={700} style={{ minWidth: 18, textAlign: "center" }}>
                RI{row.discipline}
              </Text>
            </Tooltip>

            <Tooltip
              label={row.validationId ? "Fargelegg rom etter samsvar med standardrommet for denne disiplinen. Høyere poeng betyr bedre samsvar." : "Ingen standardromvalidering tilgjengelig for denne disiplinen."}
              position="bottom"
              withArrow
              openDelay={250}
            >
              <span tabIndex={!row.validationId ? 0 : undefined}>
                <Button
                  size="xs"
                  radius="sm"
                  variant={poengActive ? "filled" : "subtle"}
                  color="blue"
                  aria-pressed={Boolean(poengActive)}
                  aria-label={`RI${row.discipline}: Poeng`}
                  disabled={!row.validationId}
                  onClick={() =>
                    row.validationId && dispatch(setActiveRoomColoringIdInRedux(row.validationId))
                  }
                  style={{ paddingLeft: 14, paddingRight: 14, fontWeight: 600 }}
                >
                  Poeng
                </Button>
              </span>
            </Tooltip>

            <Tooltip
              label={row.decisionId ? "Fargelegg rom etter manuell beslutning: Godkjent, Godkjent med avvik eller Må kontrolleres." : "Ingen beslutningsdata tilgjengelig for denne disiplinen."}
              position="bottom"
              withArrow
              openDelay={250}
            >
              <span tabIndex={!row.decisionId ? 0 : undefined}>
                <Button
                  size="xs"
                  radius="sm"
                  variant={beslutningActive ? "filled" : "subtle"}
                  color="blue"
                  aria-pressed={Boolean(beslutningActive)}
                  aria-label={`RI${row.discipline}: Beslutning`}
                  disabled={!row.decisionId}
                  onClick={() =>
                    row.decisionId && dispatch(setActiveRoomColoringIdInRedux(row.decisionId))
                  }
                  style={{ paddingLeft: 14, paddingRight: 14, fontWeight: 600 }}
                >
                  Beslutning
                </Button>
              </span>
            </Tooltip>
          </Group>
        );
      })}
    </Group>
  );
};
